const KEY = "quanty_consent_v1";

export function readConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function writeConsent(consent) {
  const payload = {
    preferences: !!consent.preferences,
    analytics: !!consent.analytics,
    marketing: !!consent.marketing,
    updated_at: new Date().toISOString(),
  };

  try {
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch (e) {
    // noop: si storage está bloqueado (Safari/privado), no reventamos
  }

  return payload;
}

export function applyConsentToGtag(consent) {
  if (!window.gtag) return;

  window.gtag("consent", "update", {
    analytics_storage: consent.analytics ? "granted" : "denied",
    ad_storage: consent.marketing ? "granted" : "denied",
    ad_user_data: consent.marketing ? "granted" : "denied",
    ad_personalization: consent.marketing ? "granted" : "denied",
    functionality_storage: "granted",
    security_storage: "granted",
  });

  // ✅ SPA fix: dispara evento tras conceder analíticas
  if (consent.analytics) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "quanty_consent_granted" });
  }

  // Meta Pixel: grant o revoke según consentimiento de marketing
  if (typeof window.fbq === 'function') {
    window.fbq('consent', consent.marketing ? 'grant' : 'revoke');
  }
}

